import { TimekeepingComponent } from '../../components'

export default function TimeKeepingOnlinePage() {
  return <TimekeepingComponent.TimeKeepingOnlineList />
}
